import { SettingsPathResolver } from '@psl/functions/navigation/path-resolvers/settings';
import { config } from '../config';
import { BecomeASellerPathResolver } from './path-resolvers/becomeASeller';
import { DefaultPathResolver } from './path-resolvers/defaultResolver';
import { DiscoveryPathResolver } from './path-resolvers/discovery';
import { MePathResolver } from './path-resolvers/me';
import { PopClipV1PathResolver } from './path-resolvers/popClipV1';
import { ReviewPathResolver } from './path-resolvers/review';
import { ShowcasePathResolver } from './path-resolvers/showcase';
import { StoreFrontPathResolver } from './path-resolvers/storefront';
import { UserProfilePathResolver } from './path-resolvers/userProfile';
import {
  PathResolveOptions,
  PathResolver,
  PathResolverContext,
  PathResolveResult,
} from './PathResolver';

export function resolveStateFromPath(
  originalPath: string,
  options: PathResolveOptions | undefined,
): PathResolveResult {
  const url = new URL(config.url + originalPath);
  const params = url.searchParams;
  const path = url.pathname;
  const urlPath = path.replace(/^\/+/, '');

  const context: PathResolverContext = {
    originalPath,
    url,
    params,
    path,
    urlPath,
    options,
  };

  const resolvers: PathResolver[] = [
    new BecomeASellerPathResolver(context),
    new DiscoveryPathResolver(context),
    new UserProfilePathResolver(context),
    new ShowcasePathResolver(context),
    new ReviewPathResolver(context),
    new PopClipV1PathResolver(context),
    new StoreFrontPathResolver(context),
    new MePathResolver(context),
    new SettingsPathResolver(context),
    new DefaultPathResolver(context),
  ];

  for (const resolver of resolvers) {
    const res = resolver.resolveStateFromPath();
    if (res != null) {
      return res;
    }
  }
}
